<template>
  <div class="unique-email-input">
    <input
      :id="id"
      ref="input"
      v-model="model"
      type="email"
      :name="name"
      :required="required"
      class="label-input__input unique-email-input__input"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
      :placeholder="placeholder"
    />

    <!-- eslint-disable vue/no-v-html -->
    <p v-show="message" class="label-input__errors" v-html="message"></p>
    <!--eslint-enable-->
  </div>
</template>

<script>
let timeout = null;

const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

export default {
  name: 'UniqueEmailInput',
  props: {
    id: {
      type: String,
      default: 'email',
    },
    name: {
      type: String,
      default: 'email',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'username',
    },
    required: Boolean,
    autofocus: Boolean,
    apiUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: this.value,
      message: null,
    };
  },
  watch: {
    /**
     * @param {string} value
     */
    model(value) {
      if (null !== timeout) {
        clearTimeout(timeout);
      }

      // reset custom error message
      this.$refs.input.setCustomValidity('');

      if (this.$refs.input.validity.valid) {
        timeout = setTimeout(() => this.callApi(value), 350);
      }
    },
  },
  methods: {
    /**
     * @param {string} email
     * @returns {Promise<any>}
     */
    callApi(email) {
      return fetch(this.apiUrl, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
        body: JSON.stringify({
          email,
        }),
      })
        .then(res => res.json())
        .then(({ message }) => {
          this.$refs.input.setCustomValidity(message || '');

          this.message = message;
        })
        .catch(() => {
          this.message = `Une erreur s'est produite, veuillez réessayer. Si le problème persiste, veuillez contacter l'administrateur du site.`;
        });
    },
  },
};
</script>
